export default __webpack_public_path__ + "static/media/Rectangle3.60dfbcd8.png";